import React from 'react';
import PropTypes from 'prop-types';
import { Modal as BaseModal } from 'react-bootstrap';

import Details from './Details';

export default function Modal({ row, show, onHide }) {
  return (
    <BaseModal
      className="student inmodal auto without-overflow"
      show={show}
      onHide={onHide}
    >
      <BaseModal.Header closeButton>
        <BaseModal.Title>Webinar Details</BaseModal.Title>
      </BaseModal.Header>

      <BaseModal.Body>
        <Details row={row} />
      </BaseModal.Body>
    </BaseModal>
  );
}

Modal.propTypes = {
  row: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
};
